import {
  primaryFontFamily,
  secondaryFontFamily,
  styled,
} from '@openeducation/oe-rn-themes';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';

import { flex, ml } from '../../style-utils';
import { OEText } from '../oe-text/oe-text';

export interface StepsCirclesProps {
  steps: number;
  currentStep: number;
  showText?: boolean;
  textStyle?: StyleProp<TextStyle>;
  currentStepStyle?: StyleProp<ViewStyle>;
  stepStyle?: StyleProp<ViewStyle>;
}

function StepsCirclesComponent({
  steps,
  currentStep,
  showText = true,
  currentStepStyle,
  stepStyle,
  textStyle,
}: StepsCirclesProps) {
  const { t } = useTranslation();

  const Steps = () => (
    <View style={[flex('flex-row', 'align-items-center')]}>
      {Array.from({ length: steps }).map((_, index) => {
        const stepNum = index + 1;
        const isActive = currentStep >= stepNum;
        return (
          <StepCircle
            key={stepNum}
            isActive={isActive}
            testID={isActive ? 'step-active-circle' : 'step-circle'}
            style={[
              stepNum === 1 && !showText && ml(0),
              isActive ? currentStepStyle : stepStyle,
            ]}
          />
        );
      })}
    </View>
  );

  return (
    <View style={[flex('flex-row', 'align-items-center')]}>
      {showText && (
        <Text fontSize={12} fontFamily={primaryFontFamily} style={textStyle}>
          {t('oeapp.lfa.step', { step: currentStep, maxSteps: steps })}
        </Text>
      )}
      <Steps />
    </View>
  );
}

export const StepsCircles = memo(StepsCirclesComponent);

interface StepCircleProps {
  isActive: boolean;
}

const Text = styled(OEText).attrs(({ fontSize, theme, fontFamily, color }) => ({
  color: color || theme.color.white,
  fontSize: fontSize || 16,
  fontFamily: fontFamily || secondaryFontFamily,
}))``;

const StepCircle = styled.View<StepCircleProps>`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.color.white : theme.color.primaryLight};
  margin-left: 8px;
`;
